export default "__VITE_ASSET__qtZ36Trz__"